import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { DroolsModule } from '@pics-module/drools';
import { BehaviorSubject, Subscription } from 'rxjs';
import { LocalService } from '@core/services/local.service';
@Component({
  selector: 'app-business-central',
  standalone: true,
  imports: [CommonModule, DroolsModule],
  templateUrl: './business-central.component.html',
  styleUrls: ['./business-central.component.scss']
})
export class BusinessCentralComponent implements OnInit {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  COMMONSERVICE: BehaviorSubject<any>;
  constructor(private permissionStore: PermissionStore, private authService: AuthService, private sessionStorage: LocalService) {
    this.COMMONSERVICE = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('PermissionsComponent');
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production,
          businessRulesHost: environment.businessRulesHost
        }
      };
      this.COMMONSERVICE.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION
      });
    });
  }
  ngOnInit(): void {
    console.log();
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
